import React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Divider from '@mui/material/Divider';
import Skeleton from '@mui/material/Skeleton';

const buttonStyles = {
  '&, :hover': { boxShadow: 'none' },
  borderRadius: 2,
  height: 33,
  width: 104,
};

const LoadCardSkeleton = () => (
  <Card sx={{ boxShadow: 6, width: 310 }}>
    <Box sx={{ p: 2, pb: 0 }}>
      <Skeleton variant="text" />
    </Box>
    <CardContent
      sx={{
        display: 'grid',
        gridColumnGap: 16,
        gridRowGap: 8,
        gridTemplateColumns: '1fr 1fr',
        justifyItems: 'center',
      }}
    >
      <Divider />
      <Divider />
      <Skeleton height={20} variant="text" width={100} />
      <Skeleton height={20} variant="text" width={100} />
      <Skeleton height={30} variant="rectangular" width={66} />
      <Skeleton height={30} variant="rectangular" width={66} />
      <Skeleton
        height={60}
        sx={{ gridColumn: '1/3', mb: 3, mt: 2 }}
        variant="rectangular"
        width={278}
      />
      <Skeleton sx={buttonStyles} variant="rectangular" />
      <Skeleton sx={buttonStyles} variant="rectangular" />
    </CardContent>
  </Card>
);

export default LoadCardSkeleton;
